import type {
  Body,
  Success,
  Failure,
  PathParams,
} from "@memento/app/endpoints/segment/create-photo";
import { GetAccessTokenFn } from "src/contexts/AuthProvider";
import { createAuthenticatedMutationHook } from "src/hooks/createAuthenticatedMutationHook";
import { getCreatePhotoSegmentEndpointUrl } from "src/libs/api-endpoint-lib";
import { mementoFetch } from "src/libs/fetcher";

type Trigger = (pathParams: PathParams, body: Body) => void;

export const useCreatePhotoSegment = createAuthenticatedMutationHook<
  Trigger,
  Success,
  Failure
>((startRequest) => ({ cardId }, body) => {
  startRequest(getCreatePhotoSegmentEndpointUrl(cardId), {
    method: "PUT",
    body,
  });
});

export async function createPhotoSegment(
  { cardId }: PathParams,
  body: Body,
  getAccessToken: GetAccessTokenFn
) {
  return await mementoFetch({
    getAccessToken,
    pathOrUrl: getCreatePhotoSegmentEndpointUrl(cardId),
    options: {
      method: "PUT",
      body,
    },
  });
}
